import { createSlice } from "@reduxjs/toolkit";
import { fetchDistrictInchargeTransferRequest } from "./thunk";

interface TransferRequestState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: TransferRequestState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const DistrictInchargeTransferRequestSlice = createSlice({
  name: "DistrictInchargeTransferRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDistrictInchargeTransferRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDistrictInchargeTransferRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchDistrictInchargeTransferRequest.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to District Incharge Transfer Request List Order";
      });
  },
});

export default DistrictInchargeTransferRequestSlice.reducer;
